import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import theme from "../../theme";

interface TableColumn {
  label: string;
  key: string;
  capitalize?: boolean;
  transform?: (value: any) => React.ReactNode;
}

interface ReusableTableProps {
  data: any;
  columns: TableColumn[];
  headerText: string;
}

const ActivityLogTable: React.FC<ReusableTableProps> = ({
  data,
  columns,
  headerText,
}) => {
  const sortedData = [...data].reverse();

  return (
    <Grid
      marginTop={"2rem"}
      style={{
        borderTopRightRadius: "5px",
        borderTopLeftRadius: "5px",
        overflow: "hidden",
      }}
    >
      <Table>
        <TableHead
          style={{
            background: theme.color?.tableHeader,
            width: "100%",
          }}
        >
          <TableRow style={{ width: "100%" }}>
            {columns.map((column, columnIndex) => (
              <TableCell
                key={columnIndex}
                style={{
                  color: theme.color?.tableGrey,
                  textAlign: "center",
                }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedData.map((item, rowIndex) => (
            <TableRow
              key={rowIndex}
              sx={{
                borderBottom: theme.border?.xsmall,
                backgroundColor: theme.color?.background,
              }}
            >
              {columns.map((column, columnIndex) => (
                <TableCell
                  key={columnIndex}
                  align="left"
                  style={{
                    textAlign: "center",
                    textTransform: column.capitalize ? "capitalize" : "none",
                    color: theme.color?.newFilterGrey,
                  }}
                >
                  {column.transform
                    ? column.transform(item[column.key])
                    : item[column.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Grid>
  );
};

export default ActivityLogTable;
